import { render } from "./CommunitiesnIndigenous.vue?vue&type=template&id=6d3868bf&scoped=true"
import script from "./CommunitiesnIndigenous.vue?vue&type=script&lang=js"
export * from "./CommunitiesnIndigenous.vue?vue&type=script&lang=js"

import "./CommunitiesnIndigenous.vue?vue&type=style&index=0&id=6d3868bf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d3868bf"]])

export default __exports__